<!--
* @Name：采购订单变更页面
* @Author: 刘玉
* @Date: 2021-12-02 10:47:19
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-02 10:47:19
-->
<template>
  <div class="approval-container">
    <van-nav-bar title="采购订单变更审批" left-arrow left-text="返回" @click-left="onClickLeft" :fixed="true" />
    <van-collapse class="approval-info" v-model="activeNames">
      <van-collapse-item name="modifyInfo" border title-class="title-class">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">变更内容查看</span>
        </template>
        <modify-info ref="modifyInfo" todo-name="PomApproval"></modify-info>
      </van-collapse-item>
      <van-collapse-item name="baseInfo" border title-class="title-class">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">采购订单基本信息</span>
        </template>
        <base-info todo-name="PomApproval" :head-info="headInfo" />
      </van-collapse-item>
      <van-collapse-item name="attachment">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">附件信息</span>
        </template>
        <hi-attachment :attach-list="attachList"></hi-attachment>
      </van-collapse-item>
      <van-collapse-item name="materialDetails">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">物料信息明细</span>
        </template>
        <material-details ref="materialDetails" todo-name="PomApproval" :currency-dict="headInfo.currencyDict" />
      </van-collapse-item>
      <van-collapse-item name="paymentPlan">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">付款计划</span>
        </template>
        <payment-plan ref="paymentPlan" todo-name="PomApproval" />
      </van-collapse-item>
      <van-collapse-item name="approvalOpinions">
        <template #title>
          <div class="vertical-line"></div>
          <span class="collapse-item-title">审批意见</span>
        </template>
        <hi-flow-approval />
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import { selectModifyData, callInterface } from '@/api/purchaseOrderModify'
import Bridge from '@/components/dsbridge'
export default {
  name: 'PomApproval',
  components: {
    'modify-info': () => import('./components/ModifyInfo.vue'),
    'base-info': () => import('@/views/PoApproval/components/BaseInfo.vue'),
    'material-details': () => import('@/views/PoApproval/components/MaterialDetails.vue'),
    'payment-plan': () => import('@/views/PoApproval/components/PaymentPlan.vue')
  },
  data() {
    return {
      activeNames: ['modifyInfo', 'approvalOpinions'],
      // poCreateHeadId: this.$store.getters.businessKey,
      poCreateHeadId: this.$route.query.businessKey,
      headInfo: {},
      attachList: [],
      apiSuccess: undefined
    }
  },
  created() {
    this.initData()
  },
  methods: {
    async initData() {
      const modifyDataResp = await selectModifyData(this.poCreateHeadId)
      this.headInfo = modifyDataResp.data
      this.attachList = this.headInfo.uploadFile
    },
    onClickLeft() {
      // this.$router.push('/todo')
      Bridge.callMethodSyn('app.jsLeavePage', '')
    },
    // 手动调接口
    async callInterface() {
      const data = Object.assign({}, this.form)
      data.coopPoModifyItems = this.$refs.materialDetails.detailsList
      data.coopPoModifyPayPlans = this.$refs.paymentPlan.planList
      const response = await callInterface(data)
      if (response && response.status === 200 && response.data.errorMsg) {
        this.apiSuccess = false
      } else {
        this.apiSuccess = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.title-class {
  background-color: #eee;
}
</style>
